import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: space-between;
  gap: 48px;
  margin-top: 64px;
  padding: 0 28px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 2%;
    margin-top: 36px;
    gap: 28px;
  }

  .mobile {
    display: none;
    width: 100%;
    padding: 0 8%;

    @media ${({ theme }) => theme.devices.mobile} {
      display: flex;
    }
  }
`;

export const GroupInfos = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    flex-direction: column;
    gap: 16px;
  }
`;

export const GroupUl = styled.div`
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }

  div {
    display: flex;
    gap: 16px;

    @media ${({ theme }) => theme.devices.mobile} {
      gap: 0px;
    }
  }

  h3 {
    display: flex;
    width: 100%;
    padding: 8px 20px 4px 16px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }

  ul {
    width: 100%;
    max-width: 172px;
    /* background-color: red; */
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 12px;
    padding-left: 0;
    list-style: none;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 100%;
      max-width: none;
    }

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      position: relative;
      padding-left: 18px;

      @media ${({ theme }) => theme.devices.mobile} {
        width: 100%;
        padding-left: 8px;
        justify-content: flex-start;
        align-items: flex-start;

        span {
          flex: 1;
          min-width: 0;
          overflow-wrap: break-word;
        }
      }

      b {
        font-weight: 700;
        margin-right: 4px;

        @media ${({ theme }) => theme.devices.mobile} {
          margin-right: 0px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.grey.white};

        @media ${({ theme }) => theme.devices.mobile} {
          top: 6px;
          width: 4px;
          height: 4px;
        }
      }
    }
  }

  .this-list {
    max-width: 100%;
    border-left: 1px solid ${({ theme }) => theme.colors.grey[500]};
    padding-left: 16px;

    @media ${({ theme }) => theme.devices.mobile} {
      padding-left: 4px;
    }
  }
`;

export const GroupCam = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.primary.main};
  padding: 16px 12px 8px 12px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    padding: 12px 8px;
    gap: 16px;

    &.desktop {
      display: none;
    }
  }
`;

export const TopCam = styled.div`
  width: 100%;
  /* margin-top: 20px; */
  display: flex;
  justify-content: center;
  gap: 16px;

  @media ${({ theme }) => theme.devices.mobile} {
    align-items: center;
  }
`;

export const TextCam = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    width: max-content;
    font-size: 56px;
    margin-bottom: -30px;
    font-weight: 300;
    font-family: 'Bebas Neue', sans-serif;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 52px;
      margin-bottom: -20px;
    }
  }

  h2 {
    display: block;
    font-size: 72px;
    margin-bottom: -22px;
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 68px;
      margin-bottom: -32px;
    }
  }
`;

export const IconCam = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.colors.grey.white};
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    max-width: 76px;
    padding: 12px 0;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 76px;
    }
  }

  p {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 20px;
    font-weight: 300;
    padding: 4px 16px 0px 16px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.primary.main};
    letter-spacing: 0 !important;
    text-transform: uppercase;
    text-align: center;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
      font-weight: 400;
    }
  }
`;

export const VideoCam = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey.black};
  border-radius: 16px;
  overflow: hidden;

  div {
    width: 100%;
    max-width: 100%;
    height: 500px;

    @media ${({ theme }) => theme.devices.mobile} {
      height: 400px;
    }
  }

  video {
    width: 340px;
  }
`;

export const BottomCam = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 6px;

  span {
    font-family: 'Bebas Neue', sans-serif;
    margin-bottom: -8px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-weight: 400;
    }
  }

  img {
    width: 100%;
    max-width: 68px;
    position: absolute;
    right: 0;
    /* margin-left: auto; */
  }
`;
